import React from 'react';
import { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas'

import './signature.css';

function Signature ( { onSubmit } ) {
    const sigCanvas = useRef(null)
    const [trimmedDataURL, setTrimmedDataURL] = useState(null)
  
    function clear () {
      sigCanvas.current.clear()
    }

    function submit() {
      onSubmit(trimmedDataURL);
    }

    const getSignature = () => {
      console.log("signature", sigCanvas?.current);
      if (sigCanvas?.current?.isEmpty()) return;
      const dataUrl = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
      setTrimmedDataURL(dataUrl);
    };
  
  
    return (
      <div>
        <div className="sig-container">
          <SignatureCanvas 
          ref={sigCanvas}
          onEnd={getSignature}
          canvasProps={{ 
            width: 400,
            height: 100,
            className: "sig-canvas" 
          }} />
        </div>
        <div className='modal-btn-container'>
          <button className="form-secondary-btn btn" onClick={clear}>Clear</button>
          <button className="form-primary-btn btn" onClick={submit}>Submit</button>
      </div>
      </div>
    )
  }

export default Signature;